import {
    InvoicesByCounterpartyItem,
    InvoiceByCounterpartySortValue,
} from "@common/types/invoice";
import { InvoicesByCustomerColumn } from "@common/types/views/invoiceViews";
import { ViewConfig } from "@lib/views";
import { CustomerNameCell } from "./cells/CustomerNameCell";
import { DrilldownAmountCell } from "./cells/DrilldownAmountCell";
import { EntitiesCell } from "./cells/EntitiesCell";

export const invoicesByCustomerViewConfig: ViewConfig<
    InvoicesByCounterpartyItem,
    InvoicesByCustomerColumn,
    InvoiceByCounterpartySortValue
> = {
    columns: {
        [InvoicesByCustomerColumn.CUSTOMER]: {
            accessorKey: "counterparty",
            name: "Customer",
            header: "Customer",
            cell: CustomerNameCell,
            sort: {
                asc: InvoiceByCounterpartySortValue.COUNTERPARTY_ASC,
                desc: InvoiceByCounterpartySortValue.COUNTERPARTY_DESC,
            },
            minSize: 200,
            maxSize: 400,
        },
        [InvoicesByCustomerColumn.CURRENT]: {
            accessorKey: "current",
            name: "Current",
            header: "Current",
            cell: DrilldownAmountCell,
            sort: {
                asc: InvoiceByCounterpartySortValue.CURRENT_ASC,
                desc: InvoiceByCounterpartySortValue.CURRENT_DESC,
            },
            minSize: 120,
            maxSize: 200,
        },
        [InvoicesByCustomerColumn.PAST_DUE_1_TO_30]: {
            accessorKey: "pastDue1To30",
            name: "1-30",
            header: "1-30",
            cell: DrilldownAmountCell,
            sort: {
                asc: InvoiceByCounterpartySortValue.PAST_DUE_1_30_ASC,
                desc: InvoiceByCounterpartySortValue.PAST_DUE_1_30_DESC,
            },
            minSize: 120,
            maxSize: 200,
        },
        [InvoicesByCustomerColumn.PAST_DUE_31_TO_60]: {
            accessorKey: "pastDue31To60",
            name: "31-60",
            header: "31-60",
            cell: DrilldownAmountCell,
            sort: {
                asc: InvoiceByCounterpartySortValue.PAST_DUE_31_60_ASC,
                desc: InvoiceByCounterpartySortValue.PAST_DUE_31_60_DESC,
            },
            minSize: 120,
            maxSize: 200,
        },
        [InvoicesByCustomerColumn.PAST_DUE_61_TO_90]: {
            accessorKey: "pastDue61To90",
            name: "61-90",
            header: "61-90",
            cell: DrilldownAmountCell,
            sort: {
                asc: InvoiceByCounterpartySortValue.PAST_DUE_61_90_ASC,
                desc: InvoiceByCounterpartySortValue.PAST_DUE_61_90_DESC,
            },
            minSize: 120,
            maxSize: 200,
        },
        [InvoicesByCustomerColumn.PAST_DUE_91_PLUS]: {
            accessorKey: "pastDue91Plus",
            name: "91+",
            header: "91+",
            cell: DrilldownAmountCell,
            sort: {
                asc: InvoiceByCounterpartySortValue.PAST_DUE_91_PLUS_ASC,
                desc: InvoiceByCounterpartySortValue.PAST_DUE_91_PLUS_DESC,
            },
            minSize: 120,
            maxSize: 200,
        },
        [InvoicesByCustomerColumn.TOTAL_OPEN]: {
            accessorKey: "open",
            name: "Open",
            header: "Open",
            cell: DrilldownAmountCell,
            sort: {
                asc: InvoiceByCounterpartySortValue.OPEN_ASC,
                desc: InvoiceByCounterpartySortValue.OPEN_DESC,
            },
            minSize: 120,
            maxSize: 200,
        },
        [InvoicesByCustomerColumn.TOTAL_PAID]: {
            accessorKey: "paid",
            name: "Paid",
            header: "Paid",
            cell: DrilldownAmountCell,
            sort: {
                asc: InvoiceByCounterpartySortValue.PAID_ASC,
                desc: InvoiceByCounterpartySortValue.PAID_DESC,
            },
            minSize: 120,
            maxSize: 200,
        },
        [InvoicesByCustomerColumn.INVOICES_COUNT]: {
            accessorKey: "invoiceCount",
            name: "Invoices",
            header: "Invoices",
            cell: DrilldownAmountCell,
            sort: {
                asc: InvoiceByCounterpartySortValue.INVOICES_COUNT_ASC,
                desc: InvoiceByCounterpartySortValue.INVOICES_COUNT_DESC,
            },
            minSize: 100,
            maxSize: 200,
        },
        [InvoicesByCustomerColumn.ENTITIES]: {
            accessorKey: "entityIds",
            name: "Entities",
            header: "",
            cell: EntitiesCell,
            minSize: 100,
            maxSize: 200,
        },
    },
};
